import apiNews from '@/api/news'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteNewsStart: '[delete news] Delete news start',
  deleteNewsSuccess: '[delete news] Delete news success',
  deleteNewsFailure: '[delete news] Delete news failure',
}

export const actionTypes = {
  deleteNews: '[delete news] Delete news',
}

const mutations = {
  [mutationTypes.deleteNewsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteNewsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteNewsFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteNews](context, {id}) {
    context.commit(mutationTypes.deleteNewsStart)
    return new Promise((resolve) => {
      apiNews
        .deleteNews(id)
        .then((response) => {
          context.commit(mutationTypes.deleteNewsSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteNewsFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
